import { useState, useMemo, createContext } from 'react';

export const initialDataState = {};
export const DataContext = createContext(initialDataState);

export const DataProvider = ({ children }) => {
  const [campusData, setCampusData] = useState(initialDataState);

  // Memoize context value for performance
  const contextValue = useMemo(
    () => ({
      campusData,
      setCampusData,
    }),
    [campusData]
  );

  return <DataContext.Provider value={contextValue}>{children}</DataContext.Provider>;
};
